import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { MdPlace } from 'react-icons/md';

const ScheduleStationDialog = dynamic(
	() => import('@/components/route/dialogs/ScheduleStationDialog'),
	{
		ssr: false,
	}
);

export default function RouteStations({ location, stations, defaultSize }) {
	const { t } = useTranslation(['route', 'common']);
	const [listSize, setListSize] = useState(defaultSize);
	const [station, setStation] = useState(null);
	if (!stations || stations.length === 0) {
		return null;
	}

	return (
		<>
			<section
				id={`stations_${location.slug}`}
				className="flex flex-col justify-start"
			>
				<h2 className="text-lg font-bold leading-tight tracking-tight text-gray-900 md:text-xl md:leading-normal lg:text-2xl">
					{t('route:stations.title', { location: location.shortName })}
				</h2>

				<div className="mt-4 flex-1">
					<ul className="space-y-2">
						{stations
							.sort()
							.slice(0, listSize)
							.map((station) => (
								<li
									key={station}
									className="cursor-pointer rounded-full px-3 py-1.5 text-sm font-medium text-blue-600 ring-1 ring-gray-300 hover:bg-blue-100 lg:text-base"
								>
									<h3
										onClick={() =>
											setStation({ location: location, name: station })
										}
										className="inline-flex items-center gap-x-1"
									>
										<MdPlace className="h-4 w-4 shrink-0 text-blue-600" />
										<span className="line-clamp-1">{station}</span>
									</h3>
								</li>
							))}
					</ul>
					{listSize < stations.length && (
						<button
							onClick={() => setListSize(stations.length)}
							className="mt-2 block cursor-pointer text-sm font-medium capitalize text-blue-600 hover:text-blue-900"
						>
							{t('common:buttons.viewAll')}
						</button>
					)}
				</div>
			</section>
			<ScheduleStationDialog
				station={station}
				isOpen={station !== null}
				onClose={() => setStation(null)}
			/>
		</>
	);
}
